var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.781 75.011 C 86.741 68.368 90 59.877 90 50.885 c 0 -15.974 -10.599 -30.135 -25.849 -34.669 C 57.511 8.119 47.436 2.942 36.173 2.942 C 16.227 2.942 0 19.169 0 39.115 C 0 48.107 3.259 56.6 9.219 63.24 l -8.633 8.634 c -0.572 0.572 -0.743 1.433 -0.434 2.18 S 1.191 75.288 2 75.288 h 25.144 c 6.85 7.485 16.517 11.77 26.683 11.77 H 88 c 0.809 0 1.538 -0.487 1.848 -1.234 c 0.31 -0.748 0.139 -1.607 -0.434 -2.18 L 80.781 75.011 z M 13.423 64.692 c 0.781 -0.781 0.781 -2.047 0 -2.828 C 7.347 55.788 4 47.709 4 39.115 C 4 21.375 18.433 6.942 36.173 6.942 s 32.173 14.433 32.173 32.173 S 53.913 71.288 36.173 71.288 H 6.828 L 13.423 64.692 z M 53.827 83.058 c -7.739 0 -15.152 -2.793 -20.95 -7.77 h 3.295 c 19.945 0 36.173 -16.228 36.173 -36.173 c 0 -6.171 -1.557 -11.984 -4.293 -17.073 C 78.848 27.383 86 38.516 86 50.885 c 0 8.593 -3.347 16.673 -9.423 22.75 c -0.781 0.781 -0.781 2.047 0 2.828 l 6.595 6.595 H 53.827 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.025 25.49 h -31.71 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 31.71 c 1.104 0 2 0.896 2 2 S 53.13 25.49 52.025 25.49 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.025 35.263 h -31.71 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 31.71 c 1.104 0 2 0.896 2 2 S 53.13 35.263 52.025 35.263 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.025 45.036 h -31.71 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 31.71 c 1.104 0 2 0.896 2 2 S 53.13 45.036 52.025 45.036 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.453 54.809 H 20.315 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 16.138 c 1.104 0 2 0.896 2 2 S 37.558 54.809 36.453 54.809 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.25db100c77e70a578d9b803ecab989bf.svg";
export { ForwardRef as ReactComponent };